export const fixedLinks = (playerAdmin = true, clubAdmin = true) => [
  {
    label: 'Nástěnka',
    href: '/',
  },
  {
    label: 'Podatelna',
    href: '/office',
  },
  ...(playerAdmin
    ? [
        {
          label: 'Správa osob',
          href: '/registration',
        },
      ]
    : []),
  ...(clubAdmin
    ? [
        {
          label: 'Správa oddílů',
          href: '/clubs/list',
        },
      ]
    : []),
];
